import { normalize_latest_version } from "../../js/latest_version.js";

export const addItem = (item) => ({
    type: 'ADD_ITEM',
    payload: item,
});

export const removeItem = (index) => ({
    type: 'REMOVE_ITEM',
    payload: index,
});


export const add_money_orders = (order) => ({
    type: 'add_money_orders',
    payload: order,
});

export const remove_money_orders = (order) => ({
    type: 'remove_money_orders',
    payload: order,
});

export const update_category_pro_lite = (order) => ({
    type: 'update_category_pro_lite',
    payload: order,
});
export const update_accounts_load_show = (accounts_load_show) => ({
    type: 'update_accounts_load_show',
    payload: accounts_load_show,
});

export const update_category_pro_max = (order) => ({
    type: 'update_category_pro_max',
    payload: order,
});

export const update_category_service = (order) => ({
    type: 'update_category_service',
    payload: order,
});

export const update_money_orders = (money) => ({
    type: 'update_money_orders',
    payload: money,
});

export const update_amount_orders = (amount) => ({
    type: 'update_amount_orders',
    payload: amount,
});

export const update_api_response = (api_response) => ({
    type: 'update_api_response',
    payload: api_response,
});

export const update_discount_orders = (discount) => ({
    type: 'update_discount_orders',
    payload: discount,
});
export const update_services_orders = (discount) => ({
    type: 'update_services_orders',
    payload: discount,
});
export const update_services_categorys = (services_categorys) => ({
    type: 'update_services_categorys',
    payload: services_categorys,
});
export const update_comments_orders = (comments_orders) => ({
    type: 'update_comments_orders',
    payload: comments_orders,
});

export const update_username_orders = (username_orders) => ({
    type: 'update_username_orders',
    payload: username_orders,
});

export const update_input_url_orders = (input_url_orders) => ({
    type: 'update_input_url_orders',
    payload: input_url_orders,
});

export const update_shop_insurance = (shop_insurance) => ({
    type: 'update_shop_insurance',
    payload: shop_insurance,
});


export const update_stable_coins = (stable_coins) => ({
    type: 'update_stable_coins',
    payload: stable_coins,
});

export const update_users_status = (users_status) => ({
    type: 'update_users_status',
    payload: users_status,
});


export const update_images_data = (images_data) => ({
    type: 'update_images_data',
    payload: images_data,
});

export const update_blob_data = (blob_data) => ({
    type: 'update_blob_data',
    payload: blob_data,
});


export const update_open_button_support = (open_button_suppor) => ({
    type: 'update_open_button_support',
    payload: open_button_suppor,
});

export const update_national_market = (national_market) => ({
    type: 'update_national_market',
    payload: national_market,
});

export const update_upload_videos_check = (upload_videos_check) => ({
    type: 'update_upload_videos_check',
    payload: upload_videos_check,
});

export const update_media_link_url = (media_link_url) => ({
    type: 'update_media_link_url',
    payload: media_link_url,
});

export const update_media_link_phone = (media_link_phone) => ({
    type: 'update_media_link_phone',
    payload: media_link_phone,
});

export const update_tiktok_users_id = (tiktok_users_id) => ({
    type: 'update_tiktok_users_id',
    payload: tiktok_users_id,
});
export const update_media_link_tik = (media_link_tik) => ({
    type: 'update_media_link_tik',
    payload: media_link_tik,
});

export const update_price_orders = (price_orders) => ({
    type: 'update_price_orders',
    payload: price_orders,
});

export const update_users_view_max = (users_view_max) => ({
    type: 'update_users_view_max',
    payload: users_view_max,
});

export const update_scams_lists_search = (scams_lists_search) => ({
    type: 'update_scams_lists_search',
    payload: scams_lists_search,
});

export const update_scams_lists_show = (scams_lists_show) => ({
    type: 'update_scams_lists_show',
    payload: scams_lists_show,
});

export const update_accounts_search_results = (accounts_search_results) => ({
    type: 'update_accounts_search_results',
    payload: accounts_search_results,
});

export const update_latest_version = (latest_version) => ({
    type: 'update_latest_version',
    payload: normalize_latest_version(latest_version),
});
